module.exports = __webpack_public_path__ + "static/media/12_cr.df95d68e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/injectionMoulds/12_cr.jpg
// module id = 195
// module chunks = 0